import { ToBase64 } from "../../../../services/api/file-api";
import { checkInvalidFiles } from "../../../../util/file-helpers";
import FluentUiIcon from "../../../../assets/fluent-ui-icon";

export const taskInitialize = {
  data: {
    ProjectTypeId: 0,
    Id: 0,
    Name: "",
    Description: "",
    Priority: 0,
    WorkItemTypeId: 0,
    AllApprovers: false,
    Recurring: "",
    RecurringStartDateTime: null,
    RecurringStartDayOfWeek: "Sundays",
    IndividualTasks: false,
    IndividualTasksNewMembers: false,
    RecurringImmediate: false,
    Attachments: [],
    AddedFormFiles: [],
  },
  isLoading: false,
};

export const recurringValues = [
  { id: "1", name: "Daily" },
  { id: "2", name: "Weekly" },
  { id: "3", name: "Monthly" },
  // { id: "5", name: "Hourly" },
  { id: "6", name: "Custom" },
];

export const recurringStartDayOfWeekValues = [
  { id: "1", name: "Sundays" },
  { id: "2", name: "Mondays" },
  { id: "3", name: "Tuesdays" },
  { id: "4", name: "Wednesdays" },
  { id: "5", name: "Thursdays" },
  { id: "6", name: "Fridays" },
  { id: "7", name: "Saturdays" },
];

export const priorityValues = [
  { id: "1", name: "Low" },
  { id: "2", name: "Medium" },
  { id: "3", name: "High" },
  { id: "4", name: "Urgent" },
];

export const BrowseFiles = (e, selectedFiles) => {
  let files = [...selectedFiles];
  let newSelectedFiles = Array.from(e.target.files);
  e.target.files = null;
  if (selectedFiles.length === 0) {
    files = [...newSelectedFiles];
  } else {
    for (const file of newSelectedFiles) {
      let fileFound = selectedFiles.find((f) => f.name === file.name);
      if (!fileFound) {
        files.push(file);
      }
    }
  }
  return files;
};

export const UploadFiles = async (selectedFiles) => {
  let files = selectedFiles;
  let fileResult = { error: false, message: "", data: {} };
  try {
    let filesValidity = checkInvalidFiles(files);

    if (filesValidity.error) {
      fileResult = filesValidity;
    } else {
      let base64Files = await FilesToBase64(files);

      fileResult = {
        ...fileResult,
        error: false,
        message: "",
        data: base64Files,
      };
    }
  } catch (error) {
    fileResult = {
      ...fileResult,
      error: true,
      message: error.toString(),
    };
  }
  return fileResult;
};

const FilesToBase64 = (files) => {
  return Promise.all(
    files.map((file) => {
      return ToBase64(file).then((result) => {
        let mimetype = result.substr(
          result.indexOf(":") + 1,
          result.indexOf(";") - result.indexOf(":") - 1
        );
        let thedocAsBytes = result.split(",")[1];
        return {
          FileName: file.name,
          FileContentType: mimetype,
          Base64String: thedocAsBytes,
        };
      });
    })
  );
};

export const DeleteBrowseFile = (name, attachments, addedFormFiles) => {
  let resultantAttachments = [...attachments];
  let resultantAddedFormFiles = [...addedFormFiles];

  let idx = resultantAttachments.findIndex((file) => file.FileName === name);
  if (idx > -1) resultantAttachments.splice(idx, 1);

  let idx2 = resultantAddedFormFiles.findIndex((file) => file.name === name);
  if (idx2 > -1) resultantAddedFormFiles.splice(idx2, 1);

  return { resultantAttachments, resultantAddedFormFiles };
};

export const PrepareDisplayFiles = (attachments, addedFiles) => {
  let displayFiles = [...attachments].concat(
    Array.from(addedFiles).map((file) => {
      return {
        FileName: file.name,
        FileSize: file.size,
      };
    })
  );

  return displayFiles.filter((obj, index) => {
    return index === displayFiles.findIndex((o) => obj.FileName === o.FileName);
  });
};

export const GetPriority = (Priority) => {
  let stringPriority = "";
  if (Priority) {
    switch (Priority) {
      case 1:
        stringPriority = "Low";
        break;
      case 2:
        stringPriority = "Medium";
        break;
      case 3:
        stringPriority = "High";
        break;
      case 4:
        stringPriority = "Urgent";
        break;
      default:
        stringPriority = "Low";
        break;
    }
  }
  return stringPriority;
};

export const GetWorkItemType = (WorkItemTypeId, taskTypes) => {
  if (WorkItemTypeId && taskTypes) {
    let taskType = taskTypes?.filter((type) => type.Id === WorkItemTypeId);
    return taskType[0]?.Name;
  }
};

export const GetIcon = (name) => {
  let extension = name.split(".")[1];
  let type = "";

  switch (extension) {
    case "pdf":
      type = "DocumentPdfRegular";
      break;
    case "xls":
    case "xlsx":
    case "xlsm":
      type = "DocumentTableRegular";
      break;
    case "ppt":
    case "pptx":
      type = "ChartMultipleRegular";
      break;
    case "doc":
    case "docx":
      type = "DocumentBulletListRegular";
      break;
    default:
      type = "ImageRegular";
      break;
  }

  return <FluentUiIcon name={type} />;
};

export const PrepareFileData = (uploadedFiles, filesOnUser) => {
  let newFiles = [...filesOnUser];
  if (uploadedFiles && filesOnUser) {
    for (let file of uploadedFiles) {
      let fileIndex = newFiles.findIndex(
        (f) => f.FileName === file.FileName && f?.DocumentId === undefined
      );
      if (fileIndex > -1) {
        newFiles[fileIndex] = { ...newFiles[fileIndex], ...file };
      }
    }
  }

  return newFiles;
};
